import { render, staticRenderFns } from "./TeacherTeam.vue?vue&type=template&id=582eccf7&"
import script from "./TeacherTeam.vue?vue&type=script&lang=js&"
export * from "./TeacherTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports